import BackboneElement from '../BackboneElement';
import merge from 'lodash/merge';
import CodeableConcept from '@/fhirworks/types/CodeableConcept';
import Quantity from '@/fhirworks/types/Quantity';

export default class MedicationAdministrationDosage extends BackboneElement {
    static __className = 'MedicationAdministrationDosage';

    __objectStructure = {
        text: String,
        site: CodeableConcept,
        route: CodeableConcept,
        method: CodeableConcept,
        dose: Quantity,
    };

    constructor(constructJson, className = 'MedicationAdministrationDosage') {
        super(constructJson, className);

        this.createAndPopulateStructure(this.__objectStructure, constructJson, this.__objectDefaults);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
